import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ShopService } from '../shop.service';
import { Title } from '@angular/platform-browser';
import * as _ from 'lodash';


@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnInit {
  public products;
  public today = new Date();
  public qty = [];
  
  public cart() {
    return this.shop.checkout;
  }
  public removeItem(id: string) {
    this.shop.removeItem(id);
  }
  public cancelQty(idx): void {
    delete this.qty[idx];
  }
  public updateQty(item, qty, idx): void {
    this.shop.updateQty(item.id, qty).then(() => {
      if (!this.shop.checkout || !this.shop.checkout.lineItems || this.shop.checkout.lineItems.length < 1) {
        this.router.navigate(['/products']);
      } else {
        delete this.qty[idx];
      }
    }).catch(console.error);
  }

  public getVariants(item:any):string {
    if (_.has(item, 'variant.selectedOptions[0].value')) {
      if (item.variant.selectedOptions.length === 1 && item.variant.selectedOptions[0].value === 'Default Title') {
        return '';
      } else {
        return _.map(item.variant.selectedOptions, 'value').join(' | ');
      }
    } else return '';
  }

  constructor(private router: Router, private shop: ShopService, private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle("Cart -- Bender Hardware");
    
  }

}



// WEBPACK FOOTER //
// /tmp/build_fdb7fa8d/src/app/cart/cart.component.ts